import React, { useState, useCallback, useEffect, useRef } from "react";
import { GoogleMap, useJsApiLoader, Marker, Polyline, GoogleMap as GoogleMapType, Circle } from "@react-google-maps/api";

// import pin from "@/public/images/pin.png";
// import ActivityCard from "./activityCard";
// import useWindowWidth from "@/hooks/useWidth";
// import { Skeleton } from "../ui/skeleton";
// import { X } from "lucide-react";
// import useGetIcon from "@/hooks/useGetIcon";
// import { setActivitiesParamsAction } from "@/app/[lng]/store/actions/activitiesActions";


const MapComp = ({
    center: centerProp,
    title,
    markers,
    style,
    date,
    allowMarkerClick,
    topLeftChildren,
    topRightChildren,
    hoveredMarker: _hoveredMarker,
    onMarkerClick,
    showPath,
    pathCoordinates,
    moreOptions,
    onDragEnd,
    onZoomChange,
    onZoomChanged,
    onClick,
}) => {
    const initialCenter =
        typeof window !== "undefined"
            ? localStorage.getItem("center")
                ? JSON.parse(localStorage.getItem("center") ?? "")
                : centerProp ?? { lat: 30.0444, lng: 31.2357 }  // Cairo coordinates
            : centerProp ?? { lat: 30.0444, lng: 31.2357 };  // Cairo coordinates

    const mapRef = useRef(null);
    const [map, setMap] = useState(null);
    const [center, setCenter] = useState(initialCenter);
    const [radius, setRadius] = useState(35000);

    useEffect(() => {
        if (centerProp) setCenter(centerProp);
        if (centerProp && map) map?.panTo({ lat: centerProp?.lat, lng: centerProp?.lng });
    }, [centerProp]);

    const [infoWindow, setInfoWindow] = useState({ index: -1, isOpen: false });

    const [hoveredMarker, setHoveredMarker] = useState(_hoveredMarker);

    useEffect(() => {
        const hovered = markers?.find((el) => el.data?.id === _hoveredMarker?.id);

        setHoveredMarker(hovered);
    }, [_hoveredMarker]);

    const googleMapsApiKey = "AIzaSyBdnm8gtFdthIBWiZA-4XXMnrkap3oi97A";
    // Not working for some reason !!

    // const googleMapsApiKey = 'AIzaSyA4kdhOJC-7OrSMm2Q2GjCMoLR7VF2n3lo' // prod
    // const googleMapsApiKey = "AIzaSyBdnm8gtFdthIBWiZA-4XXMnrkap3oi97A"; // dev general
    // const googleMapsApiKey = "AIzaSyCnIaqTP0yX4akiGmKCfI5wWem-mZ7_X8o" // dev my location

    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey,
    });

    const onLoad = useCallback(function callback(map) {
        setMap(map);
        mapRef.current = map;
    }, []);

    const onUnmount = useCallback(function callback(map) {
        setMap(null);
    }, []);

    const handleMarkerClick = (el, index) => {
        console.log(el);

        setHoveredMarker(el);
        onMarkerClick?.();

        setInfoWindow((prev) => ({
            ...prev,
            index,
            isOpen: true,
        }));
    };

    const handleInfoWindowClose = () => {
        setInfoWindow((prev) => ({
            ...prev,
            isOpen: false,
        }));
        setHoveredMarker(null);
    };

    const handleDragEnd = () => {
        if (mapRef.current) {
            // @ts-ignore
            const newCenter = mapRef.current.getCenter(); // Get the new center
            const lat = newCenter.lat();
            const lng = newCenter.lng();
            setCenter({ lat, lng });
            localStorage.setItem("center", JSON.stringify({ lat, lng }));

            onDragEnd?.({ lat, lng });
        }
    };

    const containerStyle = style ?? {
        width: "100%",
        height: "360px",
        borderRadius: "10px",
        // marginTop: '40px'
    };

    //   const windowWidth = useWindowWidth();

    const isMobile = false;

    const defaultOptions = {
        panControl: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        clickableIcons: false,
        keyboardShortcuts: false,
        scrollwheel: true,
        disableDoubleClickZoom: false,
        fullscreenControl: false,
        styles: [
            {
                featureType: "poi",
                elementType: "labels",
                stylers: [{ visibility: "off" }],
            },
        ],
        ...moreOptions,
    };

    //   const { getSvgString } = useGetIcon();

    const handleZoomChange = () => {
        if (mapRef?.current) {
            // @ts-ignore
            const currentZoom = mapRef?.current?.getZoom();
            // setZoom(currentZoom); // Update state with the current zoom level
            // setRadius((1 / currentZoom) * 35000);

            onZoomChanged?.(currentZoom);
        }
    };

    return isLoaded ? (
        <GoogleMap
            id="google-map-script"
            mapContainerStyle={containerStyle}
            center={center}
            zoom={6}  // Changed zoom level to show more of Egypt
            onUnmount={onUnmount}
            onLoad={onLoad}
            options={defaultOptions}
            onDragEnd={handleDragEnd}
            onZoomChanged={handleZoomChange}
            //   onClick={(e) => console.log("Clicked coordinates:", { lat: e.latLng.lat(), lng: e.latLng.lng() })}
            //   onClick={(e) => console.log("clicked", e)}
            onClick={(e) => onClick?.({ lat: e.latLng.lat(), lng: e.latLng.lng()})}
        >
            {topLeftChildren && <div className="absolute top-0 left-0 m-5">{topLeftChildren}</div>}
            {topRightChildren && <div className="absolute top-0 right-0 m-5">{topRightChildren}</div>}
            {/* Path Line */}
            {showPath && pathCoordinates && pathCoordinates.length > 1 && (
                <Polyline
                    path={pathCoordinates}
                    options={{
                        strokeColor: "#F55B41",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        geodesic: true,
                        icons: [
                            {
                                icon: {
                                    path: "M 0,-1 0,1",
                                    strokeOpacity: 1,
                                    scale: 3,
                                },
                                offset: "0",
                                repeat: "15px",
                            },
                        ],
                    }}
                />
            )}

            {/* <Circle
        center={center}
        radius={radius}
        options={{
          fillColor: "rgba(255, 0, 0, 0.2)",
          strokeColor: "rgba(255, 0, 0, 0.5)",
          strokeWeight: 2,
        }}
      /> */}

            {/* Markers */}
            {markers ? (
                markers.map((el, index) => {
                    if (!el?.lat || !el?.lng) return null;

                    // getIcon(el?.data?.category_icon || "FaMapMarkerAlt", hoveredMarker?.data?.id === el?.data?.id);

                    return (
                        <div key={index}>
                            {/* <Marker
                // icon={hoveredMarker?.data?.id === el?.data?.id ? pinHovered.src : pin.src}
                icon={{
                  url: getSvgString(el?.data?.category_icon || "FaMapMarkerAlt", hoveredMarker?.data?.id === el?.data?.id), // Use the rendered SVG string
                  scaledSize: new window.google.maps.Size(32, 32),
                }}
                position={{ lat: el?.lat, lng: el?.lng }}
                title={el?.formated_address}
                onClick={() => handleMarkerClick(el, index)}
              /> */}

                        </div>
                    );
                })
            ) : (
                <>
                    {/* <Marker title={title} icon={pin.src} position={center} onClick={() => handleMarkerClick(null, 0)} /> */}
                </>
            )}
        </GoogleMap>
    ) : (

        <div>Loading...</div>
    );
};

export default MapComp;